export default __webpack_public_path__ + "static/media/search_not_found.2360d28a.svg";